var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4 1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3,13.871H1V1H18.3ZM3.162,11.3H16.137V3.574H3.162Zm28.111,10.3H20.461V1H31.273Zm-8.65-2.574h6.487V3.574H22.624Zm8.65,18.02h-17.3V24.168h17.3ZM16.137,34.465H29.111V26.743H16.137ZM11.812,37.04H1V16.446H11.812Zm-8.65-2.574H9.65V19.02H3.162Z",
    transform: "translate(-1 -1)",
    fill: "#063269",
    stroke: "#063269",
    strokeWidth: 0.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/dashboard-icon.a2f85ee1b9be25fd2b42dec9cbe77a4b.svg";
export { ForwardRef as ReactComponent };